<template>
  <div id="app" class="app-shell">
    <!-- Menu Admina dla administratorów -->

    <MenuAdmin
      v-if="showMenu && isAuthenticated && userType === 'admin'"
    />

    <!-- Menu dla pracowników -->
    <MenuUzytkownikow
      v-if="showMenu && isAuthenticated && userType !== 'admin'"
    />

    <!-- Router View z klasą dla odstępu -->
    <div
      class="content app-shell__content"
      :class="{
        'content--fullscreen app-shell__content--fullscreen': route.meta.fullscreen,
      }"
    >
      <Toast ref="toast" />
      <ProgressSpinner
        v-if="isLoading"
        class="loading-spinner"
        role="progressbar"
        aria-label="Ładowanie..."
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { setToastInstance } from "@/utils/toastService"; // Poprawny import
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import MenuAdmin from "@/shared/components/navigation/MenuAdmin.vue";
import MenuUzytkownikow from "@/shared/components/navigation/MenuUzytkownikow.vue";
import { mapState } from "vuex";
import Toast from "primevue/toast";
import ProgressSpinner from "primevue/progressspinner";

export default {
  name: "App",
  components: {
    MenuUzytkownikow,
    MenuAdmin,
    Toast,
    ProgressSpinner,
    // MenuGuest, // Jeśli zdecydujesz się na menu dla gości
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const toast = ref(null);

    // Ukryj menu na ścieżce '/'
    const showMenu = computed(
      () => route.path !== "/" && !route.meta.fullscreen
    );
    onMounted(() => {
      setToastInstance(toast.value);
    });

    // Computed properties dla stanu użytkownika
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const userType = computed(() => store.getters.userType);

    return {
      toast,
      showMenu,
      isAuthenticated,
      userType,
      route,
    };
  },
  computed: {
    ...mapState(["isLoading"]),
  },
};
</script>
<style scoped>
/* 📌 Główna struktura aplikacji */
#app {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* 🔥 Tło router-view dopasowane do Menubar */
.content {
  flex-grow: 1;
}

.content--fullscreen {
  margin-top: 0;
}

/* 📌 Spinner ładowania */
.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1300; /* Zapewnia widoczność */
}
</style>
